module.exports = __webpack_public_path__ + "img/tohfaEducationalGate.32e2eb69.jpeg";